/*
 * 评论配置
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-30 19:45:01
 * @Last Modified by: zhiwei.luo@zuolin.com.com
 * @Last Modified time: 2021-03-30 16:24:55
 */

const api = {
	getScoreCount: '/orderRating/sumupStoreRating',
	listOrderRatings: '/orderRating/listOrderRatings',
	replyOrderRating: '/orderRating/replyOrderRating'
};

const routes = {
	'/comment-manage': '订单评价'
};

export {
	api,
	routes,
};
